import React, { Component } from "react";
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  UncontrolledTooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const style = {
  logoWrapper: {
    width: "100%",
    margin: "0 auto",
    overflow: "hidden",
  },
  svg: {
    width: "100%",
    fill: "#bc0002",
    height: "36px",
  },
  img: {
    height: "35px",
    width: "35px",
    borderRadius: "50%",
    margin: "0 10px",
  },
  companyLogo: {
    width: "130px",
    height: "45px",
    objectFit: "contain",
    overflow: "hidden",
  },
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      language: "",
    };
  }
  componentDidMount() {
    const language = localStorage.getItem("selectedLanguage");
    console.log(language);
    if (language === null) {
      this.setState({ language: "language" });
    } else {
      this.setState({ language: localStorage.getItem("selectedLanguage") });
    }
  }
  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-minimized");
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  }
  toggleMenu = () => {
    const { isOpen } = this.state;
    if (isOpen) {
      this.setState({ isOpen: false });
    } else {
      this.setState({ isOpen: true });
    }
  };
  changeLanguage = (value) => {
    console.log(value);
    if (value) {
      localStorage.setItem("selectedLanguage", value);
      this.setState({ language: value });
    }
  };

  render() {
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarBrand href="/" className="p-0">
          <div style={style.logoWrapper} className={`svg-logo`}>
            <img
              className={/*`img-fluid`*/ `companyLogo`}
              src={`${require("muratlamm_logo.png")}`}
              width="10%"
            />
          </div>
          <div className={`png-logo`}>
            <img
              className={`img-fluid companyLogo`}
              src={`${require("muratlamm_logo.png")}`}
              width="10%"
            />
          </div>
        </NavbarBrand>
        <NavbarToggler
          className="d-md-down-none mr-auto"
          onClick={this.sidebarToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <h3 className="mr-auto d-md-down-none admin-heading">
          Murat Lamm Admin Dashboard
        </h3>
        {this.props.currentUserImage ? (
          <div className="user-image">
            <Link
              to={{ pathname: `/users/edit-user/${this.props.currentUserId}` }}
              id="user_img_tooltip"
            >
              <img style={style.img} src={`${this.props.currentUserImage}`} />
            </Link>
            <UncontrolledTooltip placement="left" target="user_img_tooltip">
              <div className={`text-right`}>
                {this.props.currentUserFullName} <br />
                {this.props.currentUserEmail}
              </div>
            </UncontrolledTooltip>
          </div>
        ) : null}
        {/* <Dropdown isOpen={this.state.isOpen} toggle={this.toggleMenu}>
          <DropdownToggle
            variant="success"
            id="dropdown-basic"
            style={{
              marginLeft: -150,
              width: 126,
              backgroundColor: "white",
              borderColor: "#e9e9e9",
            }}
          >
            <i class="fa fa-globe" aria-hidden="true"></i>&ensp;&nbsp;
            {this.state.language}
          </DropdownToggle>

          <DropdownMenu
            style={{ transform: "translate3d(0px, 25px, 0px)" }}
            data-placement="bottom-start"
            style={{
              marginLeft: -3,
              marginTop: 6,
              minWidth: 132,
              borderRadius: 8,
            }}
          >
            <DropdownItem
              style={{ minWidth: 60, textAlign: "center" }}
              onClick={() => this.changeLanguage("Arabic")}
            >
              Arabic
            </DropdownItem>
            <DropdownItem
              style={{ minWidth: 60, textAlign: "center" }}
              onClick={() => this.changeLanguage("English")}
            >
              English
            </DropdownItem>
            <DropdownItem
              style={{ minWidth: 60, textAlign: "center" }}
              onClick={() => this.changeLanguage("Turkish")}
            >
              Turkish
            </DropdownItem>
            <DropdownItem
              style={{ minWidth: 60, textAlign: "center" }}
              onClick={() => this.changeLanguage("German")}
            >
              German
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  const user = state.user.user || {};
  return {
    currentUserImage: user.profile_image,
    currentUserId: user.id,
    currentUserFullName: user.first_name + " " + user.last_name,
    currentUserEmail: user.email,
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js